const countryList = [
    {
        longitude: 116.3,
        latitude: 39.9,
        zh: "中國大陸",
        en: "China",
        szh: "中国大陆",
        countrycode: "CN"
    },
    {
        longitude: 114.15,
        latitude: 22.15,
        zh: "香港",
        en: "HongKong",
        szh: "香港",
        countrycode: "HK"
    },
    {
        longitude: 121.5144,
        latitude: 25.04,
        zh: "台灣",
        en: "Taiwan",
        szh: "台湾",
        countrycode: "TW"
    },
    {
        longitude: -74.5,
        latitude: 40.5,
        zh: "美國",
        en: "United States",
        szh: "美国",
        countrycode: "US"
    },
    {
        longitude: 0.1,
        latitude: 51.3,
        zh: "英國",
        en: "United Kingdom",
        szh: "英国",
        countrycode: "GB"
    },
    {
        longitude: 151.1,
        latitude: -33.51,
        zh: "澳洲",
        en: "Australia",
        szh: "澳大利亚",
        countrycode: "AU"
    },
    {
        longitude: -43.11,
        latitude: -22.54,
        zh: "巴西",
        en: "Brazil",
        szh: "巴西",
        countrycode: "BR"
    },
    {
        longitude: 13.2,
        latitude: 52.3,
        zh: "德國",
        en: "Germany",
        szh: "德国",
        countrycode: "DE"
    },
    {
        longitude: 139.44,
        latitude: 35.41,
        zh: "日本",
        en: "Japan",
        szh: "日本",
        countrycode: "JP"
    },
    {
        longitude: -75.43,
        latitude: 45.25,
        zh: "加拿大",
        en: "Canada",
        szh: "加拿大",
        countrycode: "CA"
    },
    {
        longitude: 106.45,
        latitude: -6.08,
        zh: "印尼",
        en: "Indonesia",
        szh: "印度尼西亚",
        countrycode: "ID"
    },
    {
        longitude: 103.51,
        latitude: 1.18,
        zh: "新加坡",
        en: "Singapore",
        szh: "新加坡",
        countrycode: "SG"
    },
    {
        // longitude: 102.42,
        // latitude: 4.08,
        longitude: 102.42,
        latitude: 4.08,
        zh: "馬來西亞",
        en: "Malaysia",
        szh: "马来西亚",
        countrycode: "MY"
    },





    {
        longitude: 27.54,
        latitude: -26.08,
        zh: "南非",
        en: "South Africa",
        szh: "南非",
        countrycode: "ZA"
    },
    {
        longitude: 38.74,
        latitude: 9.03,
        zh: "埃塞俄比亞",
        en: "Ethiopia",
        szh: "埃塞俄比拉",
        countrycode: "ET"
    },
    {
        longitude: 7.11,
        latitude: 9.12,
        zh: "尼日利亞",
        en: "Nigeria",
        szh: "尼日利亚",
        countrycode: "NG"
    },
    {
        longitude: 3.13,
        latitude: 36.42,
        zh: "阿爾及利亞",
        en: "Algeria",
        szh: "阿尔及利亚",
        countrycode: "DZ"
    },
    {
        longitude: -7.37,
        latitude: 33.36,
        zh: "摩洛哥",
        en: "Morocco",
        szh: "摩洛哥",
        countrycode: "MA"
    },
    {
        longitude: 31.17,
        latitude: 30,
        zh: "埃及",
        en: "Egypt",
        szh: "埃及",
        countrycode: "EG"
    },
    {
        longitude: 35.4,
        latitude: -6.1,
        zh: "坦桑尼亞",
        en: "Tanzania",
        szh: "坦桑尼亚",
        countrycode: "TZ"
    },
    {
        longitude: 2.2,
        latitude: 48.51,
        zh: "法國",
        en: "France",
        szh: "法国",
        countrycode: "FR"
    },
    {
        longitude: 32.54,
        latitude: 40.02,
        zh: "土耳其",
        en: "Turkey",
        szh: "土耳其",
        countrycode: "TR"
    },
    {
        longitude: 46.44,
        latitude: 24.39,
        zh: "沙特阿拉伯",
        en: "Saudi Arabia",
        szh: "沙特阿拉伯",
        countrycode: "SA"
    },
    {
        longitude: 174.45,
        latitude: -36.55,
        zh: "紐西蘭",
        en: "New Zealand",
        szh: "新西兰",
        countrycode: "NZ"
    },
    {
        longitude: 37.37,
        latitude: 55.45,
        zh: "俄羅斯",
        en: "Russian Federation",
        szh: "俄罗斯",
        countrycode: "RU"
    },
    {
        longitude: 27.3,
        latitude: 53.51,
        zh: "白俄羅斯",
        en: "Belarus",
        szh: "白俄罗斯",
        countrycode: "BY"
    },
    {
        longitude: 20.28,
        latitude: 44.49,
        zh: "塞爾維亞",
        en: "Serbia",
        szh: "塞尔维亚",
        countrycode: "RS"
    },
    {
        longitude: 19.15,
        latitude: 47.26,
        zh: "匈牙利",
        en: "Hungary",
        szh: "匈牙利",
        countrycode: "HU"
    },
    {
        longitude: 68.51,
        latitude: 38.38,
        zh: "塔吉克",
        en: "Tajikistan",
        szh: "塔吉克斯坦",
        countrycode: "TJ"
    },
    {
        longitude: 71.3,
        latitude: 51.1,
        zh: "哈薩克",
        en: "Kazakhstan",
        szh: "哈萨克斯坦",
        countrycode: "KZ"
    },
    {
        longitude: 51.3,
        latitude: 35.45,
        zh: "伊朗",
        en: "Iran",
        szh: "伊朗",
        countrycode: "IR"
    },
    {
        longitude: 77.13,
        latitude: 28.37,
        zh: "印度",
        en: "India",
        szh: "印度",
        countrycode: "IN"
    },
    {
        longitude: 79.52,
        latitude: 6.55,
        zh: "斯里蘭卡",
        en: "Sri Lanka",
        szh: "斯里兰卡",
        countrycode: "LK"
    },
    {
        longitude: 73.08,
        latitude: 33.4,
        zh: "巴基斯坦",
        en: "Pakistan",
        szh: "巴基斯坦",
        countrycode: "PK"
    },
    {
        longitude: 100.29,
        latitude: 13.5,
        zh: "泰國",
        en: "Thailand",
        szh: "泰国",
        countrycode: "TH"
    },
    {
        longitude: 90.24,
        latitude: 23.51,
        zh: "孟加拉",
        en: "Bangladesh",
        szh: "孟加拉",
        countrycode: "BD"
    },
    {
        longitude: 12.37,
        latitude: 41.52,
        zh: "意大利",
        en: "Italy",
        szh: "意大利",
        countrycode: "IT"
    },
    {
        longitude: -3.42,
        latitude: 40.26,
        zh: "西班牙",
        en: "Spain",
        szh: "西班牙",
        countrycode: "ES"
    },
    {
        longitude: -9.05,
        latitude: 38.42,
        zh: "葡萄牙",
        en: "Portugal",
        szh: "葡萄牙",
        countrycode: "PT"
    },
]

function getCountryObj(code){
    let obj = null

    if (null != code){
        for (let i=0; i<countryList.length; i++){
            const temp = countryList[i]

            if (temp.countrycode === code){
                obj = temp
                break
            }

        }
    }

    return obj
}

export {
    countryList,
    getCountryObj
}